// extracted by mini-css-extract-plugin
export default {"home":"c-i_cZ","home__background":"c-i_ea","home__content":"c-i_eb"};